import { useLayoutEffect } from "react";
import { useSetStyleEditorView } from "../../../hooks/style";

export function MapLayers() {
  const setStyleEditorView = useSetStyleEditorView();

  useLayoutEffect(() => {
    setStyleEditorView("layers");
  }, [setStyleEditorView]);

  return null;
}
